module.exports = __webpack_public_path__ + "public/images/program/program-15.c1df24e0131fbd13f21de0c26876f2e2.jpg";